import { Button, Result } from 'antd';
import { FC } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { FormattedMessage } from 'react-intl';

const NonSupervisor: FC = () => {
  const { keycloak } = useKeycloak();

  const logout = () => {
    localStorage.removeItem('kc');
    keycloak.logout();
  };

  return (
    <Result
      title={<FormattedMessage id="UserGroup.message.nonTenantAdminUser" />}
      subTitle={
        <FormattedMessage id="UserGroup.message.nonTenantAdminUser.subTitle" />
      }
      extra={
        <Button danger data-testid="logout" onClick={logout}>
          Logout
        </Button>
      }
    />
  );
};

export default NonSupervisor;
